import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CompanyBuildingClient, CompanyBuildingView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CompanyBuildingService {
    constructor(private readonly client: CompanyBuildingClient) {}

    async save(body: CompanyBuildingView): Promise<CompanyBuildingView> {
        return await lastValueFrom(this.client.companyBuildingSave(body));
    }

    async remove(body: CompanyBuildingView): Promise<void> {
        return await lastValueFrom(this.client.companyBuildingRemoveCompanyBuilding(body));
    }

    async setAsMain(body: CompanyBuildingView): Promise<void> {
        return await lastValueFrom(this.client.companyBuildingSetBuildingAsMain(body));
    }

    async unsetAsMain(body: CompanyBuildingView): Promise<void> {
        return await lastValueFrom(this.client.companyBuildingUnsetAsMain(body));
    }
}
